import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EntityDemoComponent } from './entity-demo/entity-demo.component';
import { EntityInstanceRegisterContainerComponent } from './entity-demo/entity-instance-register-container/entity-instance-register-container.component';
import { EntityInstanceNodeComponent } from './entity-demo/entity-instance-register-container/entity-instance-node/entity-instance-node.component';
import { EntityInstanceRegisterEditorComponent } from './entity-demo/entity-instance-register-container/entity-instance-register-editor/entity-instance-register-editor.component';
import { EntityTypeDefinitionComponent } from './entity-demo/entity-type-definition/entity-type-definition.component';
import { EntitySchemaEditorComponent } from './entity-demo/entity-type-definition/entity-schema-editor/entity-schema-editor.component';
import { EntitySchemaNodeComponent } from './entity-demo/entity-type-definition/entity-schema-editor/entity-schema-node/entity-schema-node.component';
import { SchemaPropertyEditComponent } from './entity-demo/entity-type-definition/entity-schema-editor/schema-property-edit/schema-property-edit.component';

import { ComponentsModule } from '../components/components.module';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material';
import { ToastsManager } from 'ng2-toastr';
import { ToastOptions } from 'ng2-toastr/src/toast-options';
import { ToastContainer } from 'ng2-toastr';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover'; 


@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    ToastModule,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger' }) 
  ],
  declarations: [
     
    EntityInstanceRegisterContainerComponent,
    EntityInstanceNodeComponent, 
    EntityInstanceRegisterEditorComponent, 
    EntityTypeDefinitionComponent,
    EntitySchemaEditorComponent, 
    EntitySchemaNodeComponent, 
    SchemaPropertyEditComponent,
    EntityDemoComponent
  ],
  exports:[EntityDemoComponent],
  providers:[ToastsManager,
    ToastOptions],
})
export class EntityConfigModule { }
